import { filtrarMoldurasEventoPorTipo } from "@/constants/types/molduraEvento";

export default {
  getMolduras(state) {
    return state.molduras;
  },
  // Molduras fixas do evento que valem para um tipo de foto (normal/polaroid).
  getMoldurasPorTipo: (state) => (tipo) =>
    filtrarMoldurasEventoPorTipo(state.molduras, tipo),
  // true → o evento tem moldura fixa: a moldura deixa de ser opcional e as
  // molduras globais não entram na jogada.
  temMolduraFixa(state) {
    return state.molduras.length > 0;
  },
  temMolduraFixaDoTipo: (state) => (tipo) =>
    filtrarMoldurasEventoPorTipo(state.molduras, tipo).length > 0,
};
